export const subscriptionPlanTypes = {
  FREE: 'FREE',
  PRO: 'PRO',
  PLUS: 'PLUS',
  ENTERPRISE: 'ENTERPRISE',
  FREE_TRIAL: 'FREE TRIAL'
};

export const subscriptionBlockerType = {
  FULL: 'Full',
  PARTIAL: 'Partial'
};
